import { apiClient } from './apiClient.js';
import type { AuthResponse, AuthUser, ApiResponse } from '@onboarding-dashboard/shared';

export const authService = {
  async login(data: { email: string; password: string }): Promise<ApiResponse<AuthResponse>> {
    return apiClient.post<AuthResponse>('/auth/login', data);
  },

  async register(data: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    invitationToken: string;
  }): Promise<ApiResponse<AuthResponse>> {
    return apiClient.post<AuthResponse>('/auth/register', data);
  },

  async googleAuth(
    credential: string,
    invitationToken?: string
  ): Promise<ApiResponse<AuthResponse>> {
    return apiClient.post<AuthResponse>('/auth/google', {
      credential,
      invitationToken,
    });
  },

  async getCurrentUser(): Promise<ApiResponse<AuthUser>> {
    return apiClient.get<AuthUser>('/auth/me');
  },

  async logout(): Promise<ApiResponse<void>> {
    return apiClient.post('/auth/logout');
  },
};
